import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { createApiCallEffects } from '../../../common/store/generic.effects';
import { MediumApiService } from './medium.api.service';
import { MediumAction, mediumActions } from './medium.action';

@Injectable()
export class MediumEffects {
  constructor(
    private readonly mediumApiService: MediumApiService,
    private readonly action$: Actions<MediumAction>,
  ) {}

  getById = createApiCallEffects(
    this,
    this.action$,
    mediumActions.getById,
    this.mediumApiService.getById,
  );

  getList = createApiCallEffects(
    this,
    this.action$,
    mediumActions.getList,
    this.mediumApiService.getList,
  );

  add = createApiCallEffects(
    this,
    this.action$,
    mediumActions.add,
    this.mediumApiService.add,
  );

  update = createApiCallEffects(
    this,
    this.action$,
    mediumActions.update,
    this.mediumApiService.update,
  );
}
